export default __webpack_public_path__ + "static/main-c4c8a42322569660ef91f11108b780d9.png";